import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import StandardLayout from '../../templates/StandardLayout';
import { Carousel } from './Sections/Carousel/Carousel';
import { Facts } from './Sections/Facts/Facts';
import { HeaderSection } from './Sections/Header/Header';
import { HeroGirls } from './Sections/HeroGirls/HeroGirls';
import { Science } from './Sections/Science/Science';
import { MainVideo } from './Sections/MainVideo/MainVideo';
import { Video } from './Sections/Video/Video';

const UnicefPage = ({ sectionHeadings, videos, hero, description }) => (
  <StandardLayout>
    <div className="unicef-page">
      <HeaderSection sectionHeadings={sectionHeadings} />

      <MainVideo videos={videos} />

      <Facts sectionHeadings={sectionHeadings} />

      {R.path(['girlsHero', 'heading'], hero) && <HeroGirls hero={hero} />}

      <Science sectionHeadings={sectionHeadings} />

      {R.path(['carousel', 'heading'], sectionHeadings) && (
        <Carousel sectionHeadings={sectionHeadings} />
      )}

      <Video videos={videos} />

      {description && <p className="unicef-description">{description}</p>}
    </div>
  </StandardLayout>
);

UnicefPage.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.instanceOf(PropTypes.object),
  hero: PropTypes.instanceOf(PropTypes.object),
  description: PropTypes.string,
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  videos: R.prop('videos', content),
  hero: R.prop('hero', content),
  description: R.prop('description')(content),
}))(UnicefPage);
